import classnames from "classnames";
import React from "react";
import Moment from "../../../utils/Moment";

export class Task extends React.Component {
  render() {
    let item = this.props.item;
    const handleClearCompletedBatch = (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (this.props.onClearCompletedBatch) {
        this.props.onClearCompletedBatch(item);
      }
    };
    return (
      <span>
        <div className="bar-holder no-padding">
          <p className="margin-bottom-5"> 
            <i>{item.title}</i>
            <span className={classnames(["pull-right", "semi-bold", item.status === "CRITICAL" ? "text-danger" : "text-muted"])}>
              {item.width === 100 ? (
                <span>
                  <i className="fa fa-check text-success" />
                </span>
              ) : (
                <span>{item.width + "%"}</span>
              )}
            </span>
          </p>
          {item.description ? (
            <p className="margin-bottom-5" style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
              {item.description}
            </p>
          ) : null}
          {item.completed ? (
            <em className="note no-margin margin-bottom-5" style={{ display: "block" }}>
              Succeeded: <span className="text-success">{item.succeededCount}</span> - Failed:{" "}
              <span className="text-danger">{item.failedCount}</span>
            </em>
          ) : null}
          <div className={classnames(["progress", item.progressClass])}>
            <div
              className={classnames([
                "progress-bar",
                {
                  "progress-bar-success": item.status === "MINOR" || item.status === "NORMAL",
                  "bg-color-teal": item.status === "PRIMARY" || item.status === "URGENT",
                  "progress-bar-danger": item.status === "CRITICAL",
                },
              ])}
              style={{ width: item.width + "%" }}
            />
          </div>
          <em className="note no-margin">
            last updated on
            <Moment date={this.props.lastUpdate} format="MMMM Do, h:mm a" />
            {item.completed ? (
              <a href="#clear-completed-mail-batch" className="pull-right" onClick={handleClearCompletedBatch}>
                đã xem
              </a>
            ) : null}
          </em>
        </div>
      </span>
    );
  }
}
